
import { CrudService } from '@/services/crudService';
import { config } from '@/services/configService';
import { ActivatePayload, CauthPayload, RegisterPayload, ResetPasswordPayload, ResetPasswordRequestPayload } from './types';

const baseUrl = '/publiccustomers';
const crud = new CrudService({ baseUrl: config.apiUrl, allowAuth: false, handleUnauthorized: false });

export function register(payload: RegisterPayload) {
    return crud.httpPost(`${baseUrl}/register`, payload, undefined, 'json', {
        headers: {
            Accept: '*/*',
        },
    });
}

export function cauth(payload: CauthPayload) {
    return crud.httpPost(`${baseUrl}/cauth`, payload, undefined, 'json', {
        headers: {
            Accept: '*/*',
        },
    });
}

export function activate(payload: ActivatePayload) {
    return crud.httpPost(`${baseUrl}/activate`, payload, undefined, 'json', {
        headers: {
            Accept: '*/*',
        },
    });
}

export function resetPasswordRequest(payload: ResetPasswordRequestPayload) {
    return crud.httpPost(`${baseUrl}/reset-password-request-cz`, payload, undefined, 'json', {
        headers: {
            Accept: '*/*',
        },
    });
}

export function resetPassword(payload: ResetPasswordPayload) {
    return crud.httpPost(`${baseUrl}/reset-password-cz`, payload, undefined, 'json', {
        headers: {
            Accept: '*/*',
        },
    });
}

// Rehidrata el token (en memoria, para naavi) desde la cookie de sesión vigente.
export function sessionToken() {
    return crud.httpGet(`${baseUrl}/session-token`, undefined, undefined, 'json', {
        headers: { Accept: '*/*' },
    });
}

// Borra la cookie de sesión en el backend.
export function logout() {
    return crud.httpPost(`${baseUrl}/logout`, {}, undefined, 'json', {
        headers: { Accept: '*/*' },
    });
}
